import parse from "date-fns/parse";

/**
 *  `YYYY-MM-DD` フォーマットのstringをDateに変換
 */
export const parseDateString = (date: string): Date => {
  return parse(date);
};
